import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import { Animated, Platform } from 'react-native';
import { MaskDom } from '../Overlay';
import { animatedTo } from '../Overlay/utils';
const PopupDom = forwardRef((props, ref) => {
    var _a, _b;
    const { maskCloseable = true, showMask = true, maskZindex = 100, lockScroll = false, maskSideSpace, maskOpacity = 0.3, transition = 'slide', position = 'center', duration = 150, children, style, afterShow, onClose, afterClose, customStyle, scalable, onAnimatedEnd, boxStyle, } = props;
    // 弹框的尺寸
    const [size, setSize] = useState({ width: 4000, height: 4000 });
    const popupRef = useRef(null);
    const slideIn = (_a = useRef(new Animated.Value(0))) === null || _a === void 0 ? void 0 : _a.current;
    const opacity = (_b = useRef(new Animated.Value(0))) === null || _b === void 0 ? void 0 : _b.current;
    const handleClose = () => {
        const target = position === 'center' || transition === 'fade' ? opacity : slideIn;
        animatedTo({
            target,
            toValue: 0,
            duration,
            fn: () => {
                onAnimatedEnd();
                afterClose && afterClose();
            },
        });
    };
    useImperativeHandle(ref, () => ({
        close: () => {
            handleClose();
        },
    }));
    // 处理弹框被关闭
    const handleMaskPress = () => {
        if (maskCloseable) {
            onClose && onClose();
        }
    };
    useEffect(() => {
        var _a, _b;
        // 弹框展示前的处理
        if (position === 'center' || transition === 'fade') {
            animatedTo({
                target: opacity,
                toValue: 1,
                duration,
                fn: afterShow,
            });
        }
        else {
            // 非中间位置的弹框，或者 transition 值为 slide 时，需要计算尺寸，动态滑入
            (_b = (_a = popupRef.current) === null || _a === void 0 ? void 0 : _a.measure) === null || _b === void 0 ? void 0 : _b.call(_a, (_x, _y, width, height) => {
                var _a;
                setSize({ width, height });
                const toValue = position === 'bottom'
                    ? -height
                    : position === 'top'
                        ? height
                        : position === 'left'
                            ? width
                            : position === 'right'
                                ? -width
                                : 0;
                /**
                 * 函数式调用，在 H5 环境会出现弹框显示不出来的问题，并且只能在 H5 的环境下加这个代码
                 * 从控制台能查看到弹框元素的 Dom，并在光标聚焦到弹框 Dom 的时候，弹框会突然显示出来
                 * 以下通过主动调用聚焦的方式，能解决不显示的问题
                 * 如果弹框中存在其他需要聚焦的元素，可以在 afterShow 事件中设置
                 */
                if (Platform.OS === 'web') {
                    (_a = popupRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }
                animatedTo({
                    target: slideIn,
                    toValue,
                    duration,
                    fn: afterShow,
                });
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // 设置常规样式
    const commonStyles = {};
    // 设置动画样式
    const transitionStyle = {};
    if (position === 'center' || transition === 'fade') {
        Object.assign(transitionStyle, { opacity });
    }
    else if (transition === 'slide') {
        // 判断滑动的方向
        // translateDirection: 动画的运行方向
        // fillSide: 填充全屏的边
        // offset: 偏移的尺寸
        const [translateDirection, fillSide, offset] = position === 'left' || position === 'right'
            ? ['translateX', 'height', 'width']
            : ['translateY', 'width', 'height'];
        Object.assign(transitionStyle, {
            transform: [{ [translateDirection]: slideIn }],
        });
        Object.assign(commonStyles, {
            [fillSide]: '100%',
            [position]: -size[offset],
        });
    }
    return (React.createElement(MaskDom, { maskZindex: maskZindex, contentPosition: position, onPress: handleMaskPress, duration: duration, showMask: showMask, sideSpace: maskSideSpace, scalable: scalable, customStyle: { backgroundColor: customStyle === null || customStyle === void 0 ? void 0 : customStyle.maskBackgroundColor }, opacity: maskOpacity, lockScroll: lockScroll, boxStyle: boxStyle },
        React.createElement(Animated.View, { ref: popupRef, style: [commonStyles, transitionStyle, style], testID: "popup-dom" }, React.isValidElement(children)
            ? React.cloneElement(children, {
                close: () => {
                    var _a, _b, _c;
                    onClose && onClose();
                    if (typeof ((_a = children.props) === null || _a === void 0 ? void 0 : _a.close) === 'function') {
                        (_c = (_b = children.props) === null || _b === void 0 ? void 0 : _b.close) === null || _c === void 0 ? void 0 : _c.call(_b);
                    }
                },
            })
            : null)));
});
export default PopupDom;
